import {
	AcquisitionEvaluationStage,
	AcquisitionEvaluationStageMap,
	AcquisitionTransactionType,
	AcquisitionTransactionTypeMap,
	BaseRateTypes,
	BaseRateTypesMap,
	BorrowerRawLeadInterest,
	BorrowerRawLeadInterestMap,
	BusinessSalesType,
	BusinessSalesTypeMap,
	CallStatuses,
	CallStatusesMap,
	CollateralSecurityTypeMap,
	CollateralSecurityTypes,
	CountryTypeMap,
	CountryTypes,
	CovenantTargetOperatorTypesMap,
	CovenantTargetTypes,
	DataRoomStatus,
	DataRoomStatusMap,
	DataRoomWeeklyEmail,
	DataRoomWeeklyEmailMap,
	DealStatus,
	DealStatuses,
	DiligenceRequestType,
	DiligenceRequestTypeMap,
	DocumentType,
	DocumentTypeMap,
	FacilityAvailabilityLimitTypes,
	FacilityAvailabilityLimitTypesMap,
	FacilityTypeMap,
	FacilityTypes,
	InterestRateTypes,
	InterestRateTypesMap,
	LenderTypeMap,
	LenderTypes,
	LoanOptionType,
	LoanOptionTypeMap,
	MilestoneStatusResponses,
	MilestoneStatusResponsesMap,
	NatureOfBuyerType,
	NatureOfBuyerTypeMap,
	ProfileRealEstateType,
	ProfileRealEstateTypeMap,
	ProfileTangibleAssetType,
	ProfileTangibleAssetTypeMap,
	RateTypes,
	RateTypesMap,
	StatObjectTypes,
	StatObjectTypesMap,
	StructureTrancheMap,
	StructureTranches,
	TeaserDecisionStatus,
	TeaserDecisionStatusMap,
	TermSheetFeeTypes,
	TermSheetFeeTypesMap,
	Tier1BankTypeMap,
	Tier1BankTypes,
	Tier2BankTypeMap,
	Tier2BankTypes,
	Tier3ContactTypeMap,
	Tier3ContactTypes,
	TrancheEvaluation,
	TrancheTypes,
	TrancheTypesMap,
	TypicalCreditSpreadTypeMap,
	TypicalCreditSpreadTypes,
	UserRoleType,
	UserRoleTypeMap,
} from '../models';
import { DocumentDownloadType, DocumentDownloadTypeMap } from '../models/DataRoomDownload';
import {
	OutputAnalysisGroup,
	OutputAnalysisGroupMap,
	OutputAnalysisStatus,
	OutputAnalysisStatusMap,
	OutputAnalysisType,
	OutputAnalysisTypeMap,
	SummaryOutputStatus,
	SummaryOutputStatusMap,
} from '../models/OutputAnalysisStructure';
import {
	CompanyFinancialStatementTypes,
	CompanyFinancialStatementTypesMap,
	FacilityAmortizationPeriods,
	FacilityAmortizationPeriodsMap,
	FacilityFactorTypes,
	FacilityFactorTypesMap,
	TermSheetFeeFrequencies,
	TermSheetFeeFrequenciesMap,
	TermSheetGovernanceTypes,
	TermSheetGovernanceTypesMap,
	TermSheetResponses,
	TermSheetResponsesMap,
	TermSheetTypes,
	TermSheetTypesMap,
	WarrantCoverageTypes,
	WarrantCoverageTypesMap,
} from '../models/TermSheetRevision';

export function GetStructureTrancheDescription(enumValue: StructureTranches | null | undefined): string | null {
	if (enumValue == null) return null;
	return StructureTrancheMap[enumValue];
}

export function GetTeaserDecisionStatusDescription(enumValue: TeaserDecisionStatus | null | undefined): string | null {
	if (enumValue == null) return null;
	return TeaserDecisionStatusMap[enumValue];
}

export function GetStructureTrancheValue(enumValue: StructureTranches | null | undefined): number | null {
	if (enumValue == null) return null;
	switch (enumValue) {
		case 'SeniorCashFlow':
			return 1;
		case 'JuniorCashFlow':
			return 2;
		case 'VentureDebt':
			return 3;
		case 'Equity':
			return 4;
		case 'SeniorRealEstate':
			return 5;
		case 'JuniorRealEstate':
			return 6;
		case 'Sba7aRealEstate':
			return 7;
		case 'Sba7aNonRealEstate':
			return 8;
		case 'Sba504Senior':
			return 9;
		case 'Sba504Debenture':
			return 10;
		case 'UsdaBiRealEstate':
			return 11;
		case 'UsdaBiEquipment':
			return 12;
		case 'UsdaBiWorkingCapital':
			return 13;
		case 'AssetBasedEquipmentMachinery':
			return 16;
		case 'AssetBasedEquipmentVehicles':
			return 17;
		case 'AssetBasedEquipmentMarine':
			return 18;
		case 'AssetBasedEquipmentHelicopters':
			return 19;
		case 'AssetBasedEquipmentAircraft':
			return 20;
		case 'AssetBasedIntangibleIntellectualProperty':
			return 21;
		case 'AssetBasedIntangibleRoyalty':
			return 22;
		case 'PoFinancing':
			return 24;
		case 'Factoring':
			return 25;
		case 'RecurringRevenue':
			return 26;
		case 'InventoryOnly':
			return 27;
		case 'LenderFinance':
			return 28;
		case 'FloorplanFinance':
			return 29;
		case 'AssetBasedWorkingCapitalArPlusInventory':
		case 'AssetBasedWorkingCapitalAccountsReceivable':
		case 'AssetBasedWorkingCapitalInventory':
			return 30;
		case 'BridgeLoan':
			return 31;
		default:
			return null;
	}
}

export function GetDealStatusDescription(enumValue: DealStatus | null | undefined): string | null {
	if (enumValue == null) return null;
	return DealStatuses[enumValue];
}

export function GetTier1BankTypeDescription(enumValue: Tier1BankTypes | null | undefined): string | null {
	if (enumValue == null) return null;
	return Tier1BankTypeMap[enumValue];
}

export function GetDiligenceRequestTypeDescription(enumValue: DiligenceRequestType | null | undefined): string | null {
	if (enumValue == null) return null;
	return DiligenceRequestTypeMap[enumValue];
}

export function GetTier1BankTypeValue(enumValue: Tier1BankTypes | null | undefined): number | null {
	if (enumValue == null) return null;
	switch (enumValue) {
		case 'Commercial':
			return 10;
		case 'NonBank':
			return 20;
		case 'Other':
			return 99;
		default:
			return null;
	}
}

export function GetTier2BankTypeDescription(enumValue: Tier2BankTypes | null | undefined): string | null {
	if (enumValue == null) return null;
	return Tier2BankTypeMap[enumValue];
}

export function GetTier2BankTypeValue(enumValue: Tier2BankTypes | null | undefined): number | null {
	if (enumValue == null) return null;
	switch (enumValue) {
		case 'International':
			return 101;
		case 'National':
			return 102;
		case 'Regional':
			return 103;
		case 'CreditUnion':
			return 104;
		case 'CommunityBank':
			return 105;
		case 'Sblc':
			return 106;
		case 'Sbic':
			return 201;
		case 'Bdc':
			return 202;
		case 'DirectLender':
			return 203;
		case 'VentureLender':
			return 204;
		case 'AssetBased':
			return 205;
		case 'FamilyOffice':
			return 206;
		case 'PrivateEquity':
			return 207;
		default:
			return null;
	}
}

export function GetTier3ContactTypeDescription(enumValue: Tier3ContactTypes | null | undefined): string | null {
	if (enumValue == null) return null;
	return Tier3ContactTypeMap[enumValue];
}

export function GetTier3ContactTypeValue(enumValue: Tier3ContactTypes | null | undefined): number | null {
	if (enumValue == null) return null;
	switch (enumValue) {
		case 'Sba7a':
			return 1;
		case 'Sba504':
			return 2;
		case 'SeniorCash':
			return 4;
		case 'AssetWorkingCapital':
			return 8;
		case 'AssetEquipment':
			return 16;
		case 'RealEstateSenior':
			return 32;
		case 'MiddleMarket':
			return 64;
		case 'LeveragedFinance':
			return 128;
		case 'SyndicatedCapitalMarkets':
			return 256;
		case 'JuniorCash':
			return 512;
		case 'Mezzanine':
			return 1024;
		case 'StructuredPrivateEquity':
			return 2048;
		case 'RealEstateJunior':
			return 4096;
		case 'EquityMinority':
			return 16384;
		case 'EquityControl':
			return 32768;
		case 'UnitrancheStretchSenior':
			return 65536;
		case 'VentureCapital':
			return 131072;
		case 'MiddleMarketSpecialist':
			return 262144;
		case 'AssetIntangible':
			return 524288;
		case 'Usda':
			return 1048576;
		case 'VentureDebt':
			return 2097152;
		case 'RecurringRevenue':
			return 4194304;
		case 'BridgeMcaLending':
			return 8388608;
		default:
			return null;
	}
}

export function GetProfileRealEstateTypeDescription(
	enumValue: ProfileRealEstateType | null | undefined
): string | null {
	if (enumValue == null) return null;
	return ProfileRealEstateTypeMap[enumValue];
}

export function GetTrancheTypesDescription(enumValue: TrancheTypes | null | undefined): string | null {
	if (enumValue == null) return null;
	return TrancheTypesMap[enumValue];
}

export function GetTypicalCreditSpreadTypeDescription(
	enumValue: TypicalCreditSpreadTypes | null | undefined
): string | null {
	if (enumValue == null) return null;
	return TypicalCreditSpreadTypeMap[enumValue];
}

export function GetProfileTangibleAssetTypeDescription(
	enumValue: ProfileTangibleAssetType | null | undefined
): string | null {
	if (enumValue == null) return null;
	return ProfileTangibleAssetTypeMap[enumValue];
}

export function GetNatureOfBuyerTypeDescription(enumValue: NatureOfBuyerType | null | undefined): string | null {
	if (enumValue == null) return null;
	return NatureOfBuyerTypeMap[enumValue];
}

export function GetAcquisitionTransactionTypeDescription(
	enumValue: AcquisitionTransactionType | null | undefined
): string | null {
	if (enumValue == null) return null;
	return AcquisitionTransactionTypeMap[enumValue];
}

export function GetAcquisitionEvaluationStageDescription(
	enumValue: AcquisitionEvaluationStage | null | undefined
): string | null {
	if (enumValue == null) return null;
	return AcquisitionEvaluationStageMap[enumValue];
}

export function GetOutputAnalysisGroupDescription(enumValue: OutputAnalysisGroup | null | undefined): string | null {
	if (enumValue == null) return null;
	return OutputAnalysisGroupMap[enumValue];
}

export function GetOutputAnalysisTypeDescription(enumValue: OutputAnalysisType | null | undefined): string | null {
	if (enumValue == null) return null;
	return OutputAnalysisTypeMap[enumValue];
}

export function GetOutputAnalysisStatusDescription(enumValue: OutputAnalysisStatus | null | undefined): string | null {
	if (enumValue == null) return null;
	return OutputAnalysisStatusMap[enumValue];
}

export function GetSummaryOutputStatusDescription(enumValue: SummaryOutputStatus | null | undefined): string | null {
	if (enumValue == null) return null;
	return SummaryOutputStatusMap[enumValue];
}

export function GetDataRoomStatusDescription(enumValue: DataRoomStatus | null | undefined): string | null {
	if (enumValue == null) return null;
	return DataRoomStatusMap[enumValue];
}

export function GetDataRoomWeeklyEmailDescription(enumValue: DataRoomWeeklyEmail | null | undefined): string | null {
	if (enumValue == null) return null;
	return DataRoomWeeklyEmailMap[enumValue];
}

export function GetFacilityTypeDescription(enumValue: FacilityTypes | null | undefined): string | null {
	if (enumValue == null) return null;
	return FacilityTypeMap[enumValue];
}

export function GetCollateralSecurityTypeDescription(
	enumValue: CollateralSecurityTypes | null | undefined
): string | null {
	if (enumValue == null) return null;
	return CollateralSecurityTypeMap[enumValue];
}

export function GetFacilityAvailabilityLimitTypeDescription(
	enumValue: FacilityAvailabilityLimitTypes | null | undefined
): string | null {
	if (enumValue == null) return null;
	return FacilityAvailabilityLimitTypesMap[enumValue];
}

export function GetDocumentTypeDescription(enumValue: DocumentType | null | undefined): string | null {
	if (enumValue == null) return null;
	return DocumentTypeMap[enumValue];
}

export function GetDocumentDownloadTypeDescription(enumValue: DocumentDownloadType | null | undefined): string | null {
	if (enumValue == null) return null;
	return DocumentDownloadTypeMap[enumValue];
}

export function GetLoanOptionType(enumValue: LoanOptionType | null | undefined): string | null {
	if (enumValue == null) return null;
	return LoanOptionTypeMap[enumValue];
}

export function GetUserRoleType(enumValue: UserRoleType | null | undefined): string | null {
	if (enumValue == null) return null;
	return UserRoleTypeMap[enumValue];
}

export function GetTermSheetType(enumValue: TermSheetTypes | null | undefined): string | null {
	if (enumValue == null) return null;
	return TermSheetTypesMap[enumValue];
}

export function GetTermSheetGovernanceType(enumValue: TermSheetGovernanceTypes | null | undefined): string | null {
	if (enumValue == null) return null;
	return TermSheetGovernanceTypesMap[enumValue];
}

export function GetWarrantCoverageType(enumValue: WarrantCoverageTypes | null | undefined): string | null {
	if (enumValue == null) return null;
	return WarrantCoverageTypesMap[enumValue];
}

export function GetTermSheetResponse(enumValue: TermSheetResponses | null | undefined): string | null {
	if (enumValue == null) return null;
	return TermSheetResponsesMap[enumValue];
}

export function GetCovenantTargetTypeDescription(enumValue: CovenantTargetTypes | null | undefined): string | null {
	if (enumValue == null) return null;
	return CovenantTargetOperatorTypesMap[enumValue];
}

export function GetCompanyFinancialStatementTypesDescription(
	enumValue: CompanyFinancialStatementTypes | null | undefined
): string | null {
	if (enumValue == null) return null;
	return CompanyFinancialStatementTypesMap[enumValue];
}

export function GetFacilityAmortizationPeriodsDescription(
	enumValue: FacilityAmortizationPeriods | null | undefined
): string | null {
	if (enumValue == null) return null;
	return FacilityAmortizationPeriodsMap[enumValue];
}

export function GetMilestoneStatusResponsesDescription(
	enumValue: MilestoneStatusResponses | null | undefined
): string | null {
	if (enumValue == null) return null;
	return MilestoneStatusResponsesMap[enumValue];
}

export function GetInterestRateTypesDescription(enumValue: InterestRateTypes | null | undefined): string | null {
	if (enumValue == null) return null;
	return InterestRateTypesMap[enumValue];
}

export function GetBaseRateTypesDescription(enumValue: BaseRateTypes | null | undefined): string | null {
	if (enumValue == null) return null;
	return BaseRateTypesMap[enumValue];
}

export function GetFacilityFactorTypesDescription(enumValue: FacilityFactorTypes | null | undefined): string | null {
	if (enumValue == null) return null;
	return FacilityFactorTypesMap[enumValue];
}

export function GetCountryTypeDescription(enumValue: CountryTypes | null | undefined): string | null {
	if (enumValue == null) return null;
	return CountryTypeMap[enumValue];
}

export function GetRateTypesDescription(enumValue: RateTypes | null | undefined): string | null {
	if (enumValue == null) return null;
	return RateTypesMap[enumValue];
}

export function GetTermSheetFeeFrequenciesDescription(
	enumValue: TermSheetFeeFrequencies | null | undefined
): string | null {
	if (enumValue == null) return null;
	return TermSheetFeeFrequenciesMap[enumValue];
}

export function GetTermSheetFeeTypesDescription(enumValue: TermSheetFeeTypes | null | undefined): string | null {
	if (enumValue == null) return null;
	return TermSheetFeeTypesMap[enumValue];
}

export function GetCallStatusDescription(enumValue: CallStatuses | null | undefined): string | null {
	if (enumValue == null) return null;
	return CallStatusesMap[enumValue];
}

export function GetLenderTypesDescription(enumValue: LenderTypes | null | undefined): string | null {
	if (enumValue == null) return null;
	return LenderTypeMap[enumValue];
}

export function GetStatObjectTypesDescription(enumValue: StatObjectTypes | null | undefined): string | null {
	if (enumValue == null) return null;
	return StatObjectTypesMap[enumValue];
}

export function GetBorrowerRawLeadInterestDescription(
	enumValue: BorrowerRawLeadInterest | null | undefined
): string | null {
	if (enumValue == null) return null;
	return BorrowerRawLeadInterestMap[enumValue];
}

export function GetStructureTrancheOrganizedList(
	selectedTranches: TrancheEvaluation[] | null | undefined
): SelectOptionItem[] {
	let items = [] as SelectOptionItem[];

	if (selectedTranches && selectedTranches.length > 0) {
		items.push({
			isOptionGroup: true,
			text: 'Selected Options',
			value: '',
		} as SelectOptionItem);
		selectedTranches
			.sort((a, b) =>
				StructureTrancheMap[a.structureTranche ?? 'AssetBasedWorkingCapitalAccountsReceivable'].localeCompare(
					StructureTrancheMap[b.structureTranche ?? 'AssetBasedWorkingCapitalAccountsReceivable']
				)
			)
			.forEach(tranche => {
				const text =
					StructureTrancheMap[tranche.structureTranche ?? 'AssetBasedWorkingCapitalAccountsReceivable'];

				if (
					items.filter(i => i.text == text).length == 0 &&
					text != 'ABL Working Capital - Inventory' &&
					text != 'ABL Working Capital - Accounts Receivable'
				) {
					items.push({
						isOptionGroup: false,
						text: text,
						value: tranche.structureTranche,
					} as SelectOptionItem);
				}
			});

		items.push({
			isOptionGroup: true,
			text: 'Other Tranches',
			value: '',
		} as SelectOptionItem);
	}

	let secondList = [] as SelectOptionItem[];

	Object.entries(StructureTrancheMap).map(([value, description]) => {
		const existCount = items.filter(i => i.text == description).length;
		if (existCount == 0) {
			secondList.push({
				isOptionGroup: false,
				text: description,
				value: value,
			} as SelectOptionItem);
		}
	});

	secondList.sort((a, b) => a.text.localeCompare(b.text)).map(i => items.push(i));

	return items;
}

export interface SelectOptionItem {
	isOptionGroup: boolean;
	text: string;
	value: string;
}
export function GetBusinessSalesTypeDescription(enumValue: BusinessSalesType | null | undefined): string | null {
	if (enumValue == null) return null;
	return BusinessSalesTypeMap[enumValue];
}
